import { createErrorReducer } from 'store/redux';

import * as actionTypes from './actionTypes';

export default createErrorReducer(actionTypes.ERROR_RESET, actionTypes.FAILURE);
